module.exports = __webpack_public_path__ + "img/Russia.fad876cb.png";